// extracted by mini-css-extract-plugin
export var columnList = "_ds-0";